import { AppThunkDispatch, REACT_APP_QWEALTH_API_V3 } from '@qwealth/qdata';
import { errorHandler } from '../../services/axiosService';
import { TaxDocument } from '../models/taxDocuments';
import axios from 'axios';

export const fetchTaxDocumentsByYearAndQid = async (taxYear: number, qid: string, dispatch?: AppThunkDispatch): Promise<TaxDocument[]> => {
  try {
    const response = await axios.get(`${REACT_APP_QWEALTH_API_V3}/tax/${taxYear}/${qid}`);
    return response.data;
  } catch (e) {
    if (dispatch) {
      errorHandler(dispatch, 'API Error: Failed Fetching Tax Documents')(e);
    }
    return [];
  }
};

// ToDo: implement this
export const fetchTaxDocumentFile = async (s3Filename: string) => {};
